/**
 *
 * @module playbackMetricsProvider
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';
import PlaybackEventListener from './playbackEventListener';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class PlaybackMetricsProvider
 * @since 2.0.0
 *
 */
export default class PlaybackMetricsProvider {

    /**
     *
     * @access public
     * @desc Gets a snapshot of information about media playback.
     * @returns {Promise<PlaybackMetrics>} - instance that contains a snapshot
     * of information about media playback.
     *
     */
    getPlaybackMetrics() {

        const errorMessage = {
            method: 'PlaybackMetricsProvider.getPlaybackMetrics()'
        };

        return new Promise((resolve, reject) => {
            return reject(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

    /**
     *
     * @access public
     * @param {PlaybackEventListener} listener
     * @returns {Promise<PlaybackMetrics>}
     *
     */
    addListener(listener) {

        const errorMessage = {
            method: 'PlaybackMetricsProvider.addListener(listener)',
            get listener() {
                return `${this.method} needs PlaybackEventListener instance`;
            }
        };

        instanceStrict(listener, PlaybackEventListener, errorMessage.listener, InvalidArgumentException);

        return new Promise((resolve, reject) => {
            return reject(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

    /**
     *
     * @access public
     * @param {PlaybackEventListener} listener
     * @returns {Promise<PlaybackMetrics>}
     *
     */
    removeListener(listener) {

        const errorMessage = {
            method: 'PlaybackMetricsProvider.removeListener(listener)',
            get listener() {
                return `${this.method} needs PlaybackEventListener instance`;
            }
        };

        instanceStrict(listener, PlaybackEventListener, errorMessage.listener, InvalidArgumentException);

        return new Promise((resolve, reject) => {
            return reject(new Error(`${errorMessage.method} - not-implemented`));
        });

    }

}



// WEBPACK FOOTER //
// ./src/media/playbackMetricsProvider.js